;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sweetalert = require("sweetalert2");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "Pay",
  props: ["customer_id", "service_id", "agent_id", "agent_spending_api"],
  data: function data() {
    return {
      account_id: null,
      amount: null,
      invoice_no: null,
      url: null,
      current_bal: null,
      account_bal: 0,
      internal_pesaflow_gateway: null,
      con_secret: null,
      con_key: null,
      base_url: ""
    };
  },

  mounted: function mounted() {
    this.invoice_no = this.$attrs["invoice_no"];
    this.amount = this.$attrs["amount"];
    this.internal_pesaflow_gateway = this.$attrs["internal_pesaflow_gateway"];
    this.account_id = this.$attrs["account_id"];
    this.current_bal = this.$attrs["account_bal"];
    this.account_bal = this.$attrs["num_acc_bal"];
    this.url = this.$attrs["pay_url"];
    this.consumer_secret = this.$attrs["con_secret"];
    this.consumer_key = this.$attrs["con_key"];
    this.base_url = this.$attrs["base_url"];
  },
  methods: {
    authorize_and_execute_payment: function authorize_and_execute_payment() {
      var _this = this;

      var url = this.base_url + "/api/oauth/generate/token";
      var payload = {
        secret: this.consumer_secret,
        key: this.consumer_key
      };
      Vue.axios.post(url, payload).then(function (response) {
        _this.api_token = response.data.token;

        var payload = {
          client_invoice_ref: _this.invoice_no,
          amount: _this.amount,
          pesaflow_account_id: _this.account_id,
          payment_gateway_id: _this.internal_pesaflow_gateway
        };
        var api_headers = { Authorization: "Bearer " + _this.api_token };
        Vue.axios.post(_this.url, payload, {
          headers: api_headers
        }).then(function (response) {
          this.sync_agent_spending();
        }).catch(function (error) {
          _sweetalert2.default.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong. Contact support for assistance"
          });
        });
      }).catch(function (error) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong. Contact support for assistance"
        });
      }).then(function () {});
    },
    make_payment: function make_payment() {
      if (this.account_id == null || this.account_id === "") {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "It seems your agent account is not activated. Contact support for assistance"
        });
        return;
      }
      if (parseFloat(this.account_bal) < parseFloat(this.amount)) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Insufficient funds to carry out this transaction"
        });
        return;
      }

      this.authorize_and_execute_payment();
    },
    sync_agent_spending: function sync_agent_spending() {
      var payload = {
        agent_id: this.agent_id,
        user_msisdn: this.customer_id,
        service_id: this.service_id,
        trx_ref: this.invoice_no,
        amount: this.amount
      };
      Vue.axios.post(this.agent_spending_api, payload).then(function (response) {}).catch(function (error) {});
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"btn btn-primary",attrs:{"href":"#","data-toggle":"modal","data-target":"#pay-modal"}},[_vm._v("Pay")]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"pay-modal","tabindex":"-1","role":"dialog","aria-labelledby":"pay-modal","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"id":"pay-modal","role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('form',{attrs:{"onsubmit":"return false;"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"overflow":"auto"}},[_c('div',{staticClass:"md-form mb-5"},[_c('label',{attrs:{"data-error":"wrong","data-success":"right"}},[_vm._v("Ref")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoice_no),expression:"invoice_no"}],staticClass:"form-control",attrs:{"type":"text","readonly":"true"},domProps:{"value":(_vm.invoice_no)},on:{"input":function($event){if($event.target.composing){ return; }_vm.invoice_no=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"data-error":"wrong","data-success":"right"}},[_vm._v("Pay Amount")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.amount),expression:"amount"}],staticClass:"form-control",attrs:{"type":"number","readonly":"true"},domProps:{"value":(_vm.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.amount=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("Close")]),_vm._v(" "),_c('input',{staticClass:"btn btn-primary",attrs:{"type":"button","value":"Make payment"},on:{"click":_vm.make_payment}})])])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("Pay from Account")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-473ed3ba", __vue__options__)
  } else {
    hotAPI.reload("data-v-473ed3ba", __vue__options__)
  }
})()}